<template>
  <v-dialog v-model="dataValue" persistent max-width="510">
    <v-card>
      <v-card-title class="text-h5">
        <p class="fontGrey--text pr-3 font-weight-bold">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text v-if="!isApn">
        {{ content }}
      </v-card-text>
      <ConfigSetting v-else :currMode="content" />
      <v-card-actions>
        <v-btn
          color="success"
          plain
          text
          x-large
          class="text-h6 font-weight-bold"
          @click="dataValue = !dataValue"
        >
          סגור
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import boolMixin from "@/mixins/boolMixin.js";

export default {
  name: "InfoPopup",
  mixins: [boolMixin],
  components: {
    ConfigSetting: () => import("@/components/Settings/Network/ConfigsSetting"),
  },
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    content: {
      type: [Object, String],
      required: false,
    //   default: () => {}
    },
    isApn: {
      type: Boolean,
      required: false,
      default: false,
    },
    // apnOptions: {
    //   type: Array,
    //   required: false,
    // },
  },
};
</script>
